<ng-container *ngIf="isConnected">
    <div class="wrapper" [dir]="options.direction">

        <app-site-header></app-site-header>

        <app-site-breadcrumbs></app-site-breadcrumbs>

        <section id="content">
            <router-outlet></router-outlet>
        </section>

        <app-site-footer></app-site-footer>

    </div>
</ng-container>
<ng-container *ngIf="!isConnected">
    <app-maintenance-page></app-maintenance-page>
</ng-container>
